__turbopack_context__.v({
  "card": "domain-module__sr9eCq__card",
  "cardAmount": "domain-module__sr9eCq__cardAmount",
  "cardFrom": "domain-module__sr9eCq__cardFrom",
  "cardPer": "domain-module__sr9eCq__cardPer",
  "cardPrice": "domain-module__sr9eCq__cardPrice",
  "cardSlot": "domain-module__sr9eCq__cardSlot",
  "cardTld": "domain-module__sr9eCq__cardTld",
  "cards": "domain-module__sr9eCq__cards",
  "chip": "domain-module__sr9eCq__chip",
  "chipPrice": "domain-module__sr9eCq__chipPrice",
  "chipTld": "domain-module__sr9eCq__chipTld",
  "chips": "domain-module__sr9eCq__chips",
  "control": "domain-module__sr9eCq__control",
  "controlInput": "domain-module__sr9eCq__controlInput",
  "controlLabel": "domain-module__sr9eCq__controlLabel",
  "controls": "domain-module__sr9eCq__controls",
  "error": "domain-module__sr9eCq__error",
  "field": "domain-module__sr9eCq__field",
  "footnote": "domain-module__sr9eCq__footnote",
  "hint": "domain-module__sr9eCq__hint",
  "input": "domain-module__sr9eCq__input",
  "label": "domain-module__sr9eCq__label",
  "notice": "domain-module__sr9eCq__notice",
  "pageButton": "domain-module__sr9eCq__pageButton",
  "pageInfo": "domain-module__sr9eCq__pageInfo",
  "pagination": "domain-module__sr9eCq__pagination",
  "resultAction": "domain-module__sr9eCq__resultAction",
  "resultList": "domain-module__sr9eCq__resultList",
  "resultName": "domain-module__sr9eCq__resultName",
  "resultPrice": "domain-module__sr9eCq__resultPrice",
  "resultRow": "domain-module__sr9eCq__resultRow",
  "results": "domain-module__sr9eCq__results",
  "resultsHeading": "domain-module__sr9eCq__resultsHeading",
  "search": "domain-module__sr9eCq__search",
  "sortButton": "domain-module__sr9eCq__sortButton",
  "status": "domain-module__sr9eCq__status",
  "submit": "domain-module__sr9eCq__submit",
  "summary": "domain-module__sr9eCq__summary",
  "table": "domain-module__sr9eCq__table",
  "tableWrap": "domain-module__sr9eCq__tableWrap",
  "tldName": "domain-module__sr9eCq__tldName",
  "tldPopular": "domain-module__sr9eCq__tldPopular",
  "warning": "domain-module__sr9eCq__warning",
});
